import { OrderType } from 'types/checkout'
import { FirebaseDocRefType, FirebaseDocumentDataType, FirebaseSnapshotType } from 'firebase/index'
import { Action, Dispatch } from 'redux'
import { BasketType } from 'types/basket'
import { fetchBasketsAction } from 'reducks/basket/actions'

const fetchBasketsFromOrders = (orders: OrderType[], storeRef: FirebaseDocRefType) => {
  return async (dispatch: Dispatch<Action>) => {
    const promises = []

    for (let i = 0; i < orders.length; i = (i + 1) | 0) {
      const order = orders[i]
      promises.push(
        storeRef
          .collection('store_baskets')
          .where('date', '==', order.date)
          .where('user_id', '==', order.user_id)
          .get()
          .then((snapshots: FirebaseDocumentDataType) => {
            const baskets: BasketType[] = []
            snapshots.forEach((snapshot: FirebaseSnapshotType) => {
              const data = snapshot.data() as BasketType
              data.basket_id = snapshot.id
              baskets.push(data)
            })
            return baskets
          })
      )
    }

    const baskets = await Promise.all(promises)
      .then((result) => {
        const _baskets: BasketType[] = []
        for (let i = 0; i < result.length; i = (i + 1) | 0) {
          const basketList = result[i]
          for (let j = 0; j < basketList.length; j = (j + 1) | 0) {
            const basket = basketList[j]
            if (_baskets.some((_basket) => _basket.basket_id === basket.basket_id)) continue
            _baskets.push(basket)
          }
        }
        return _baskets
      })
      .catch((error: unknown) => {
        console.error(error)
        return []
      })

    dispatch(fetchBasketsAction(baskets))
  }
}

export default fetchBasketsFromOrders
